<template>
  <b-table
    :data="blockedUsers"
    hoverable
    style="cursor: pointer"
    @click="showBlockDetails"
  >
    <b-table-column
      field="blockedUsers.createdAt"
      :label="$t('users.blockDate')"
      v-slot="props"
    >
      {{
        moment
          .utc(props.row.createdAt)
          .add(preferences.timezone, "h")
          .format("DD/MM/YY")
      }}
    </b-table-column>

    <b-table-column
      field="blockedUsers.user.name"
      :label="$t('users.name')"
      v-slot="props"
    >
      {{
        `${props.row.user.personalInfo.name} ${props.row.user.personalInfo.surname}`
      }}
      {{
        props.row.user.personalInfo.socialName
          ? `(${$t("common.socialName")}: ${
              props.row.user.personalInfo.socialName
            })`
          : ""
      }}
    </b-table-column>

    <b-table-column
      field="blockedUsers.user.email"
      :label="$t('users.email')"
      v-slot="props"
    >
      {{ props.row.user.personalInfo.email }}
    </b-table-column>

    <template slot="empty">
      <table-empty-template />
    </template>

    <b-modal :active.sync="isBlockDetailsModalOpen">
      <block-details-modal :details="details" />
    </b-modal>
  </b-table>
</template>

<script>
import { mapGetters } from "vuex";
import tableEmptyTemplate from "../common/TableEmptyTemplate";
import blockDetailsModal from "./BlockDetailsModal";

export default {
  components: {
    tableEmptyTemplate,
    blockDetailsModal
  },

  data() {
    return {
      isBlockDetailsModalOpen: false,
      details: {}
    };
  },

  methods: {
    showBlockDetails(details) {
      this.isBlockDetailsModalOpen = true;
      this.details = details;
    }
  },

  computed: {
    ...mapGetters(["blockedUsers", "preferences"])
  }
};
</script>
